module.exports = __webpack_public_path__ + "static/media/group-chat.c3e8e1e3.svg";